// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"fe23b86d","736":"b518d6bb"}[chunkId] + ".chunk.js";
};